import { useEffect, useState } from 'react';
import { KYC_VERIFICATION_CONSTANTS } from '../constants';

interface UseKycAnimationProps {
  shouldShow: boolean;
}

interface UseKycAnimationReturn {
  isVisible: boolean;
  shouldRender: boolean;
}

export const useKycAnimation = ({
  shouldShow,
}: UseKycAnimationProps): UseKycAnimationReturn => {
  const [isVisible, setIsVisible] = useState(false);
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    if (!shouldShow) {
      return;
    }

    // Show banner with a small delay for nice animation
    const renderTimer = setTimeout(() => {
      setShouldRender(true);

      // Add additional delay for animation
      const animationTimer = setTimeout(() => {
        setIsVisible(true);
      }, KYC_VERIFICATION_CONSTANTS.ANIMATION.ANIMATION_DELAY);

      return () => clearTimeout(animationTimer);
    }, KYC_VERIFICATION_CONSTANTS.ANIMATION.RENDER_DELAY);

    return () => clearTimeout(renderTimer);
  }, [shouldShow]);

  return {
    isVisible,
    shouldRender,
  };
};
